import { on } from "delegated-events";
import ajax from "@common/scripts/ajax";
import { validateForm } from "@common/scripts/validation";

const toggleSubmit = (form) => {
  const submitButton =
    form.querySelector('[type="submit"]') || document.querySelector(`[type="submit"][form="${form.id}"]`);

  if (submitButton) {
    submitButton.disabled = !submitButton.disabled;
    submitButton.classList.toggle("is-loading");
  }
};

const showFormMessages = (holder, message, success, autoHide) => {
  holder.style.display = "block";
  holder.innerHTML = message;

  if (success) {
    holder.classList.remove("form-message-error");
  } else {
    holder.classList.add("form-message-error");
  }

  if (autoHide) {
    setTimeout(() => {
      holder.style.display = "none";
    }, 5000);
  }
};

const trackGoogleAnalytics = (event) => {
  if (window.dataLayer) {
    window.dataLayer.push(event);
  }
};

export default {
  init: () => {
    on("submit", "[data-ajax-form]", async (e) => {
      e.preventDefault();

      const form = e.currentTarget;
      const formMessages = form.querySelector(".form-messages");

      toggleSubmit(form);

      const isValid = validateForm(form);

      if (!isValid) {
        toggleSubmit(form);
        return;
      }

      const formData = new FormData(form);

      try {
        const res = await ajax.post(form.action, { body: formData }).json();

        if (res.success) {
          if (res.ga) {
            res.ga.forEach((event) => trackGoogleAnalytics(event));
          }

          form.reset();
          form.querySelectorAll("select").forEach((x) => (x.value = null));
          form.querySelectorAll(".form-content").forEach((x) => x.classList.add("hidden"));
        }

        if (res.message) {
          showFormMessages(formMessages, res.message, res.success, false);
        }
      } catch (error) {
        showFormMessages(formMessages, "Sorry, there was a problem with your submission");
      } finally {
        toggleSubmit(form);
      }
    });
  },
};
